<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     根组件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default{
  name: 'App'
}
</script>
